/**
 * 入庫明細包裝／庫編排序：stockNo 升序；空值最後；同庫編以 inventoryStockId 穩定排序。
 */

function resolvePackageStockNo(pkg) {
  return String(pkg?.stockNo ?? pkg?.invStock?.stockNo ?? '').trim();
}

function resolvePackageInventoryStockId(pkg) {
  return String(
    pkg?.inventoryStockId
    ?? pkg?.invStock?.id
    ?? '',
  );
}

function compareStockNoAscEmptyLast(leftNo, rightNo) {
  const leftEmpty = !leftNo;
  const rightEmpty = !rightNo;
  if (leftEmpty && rightEmpty) {
    return 0;
  }
  if (leftEmpty) {
    return 1;
  }
  if (rightEmpty) {
    return -1;
  }
  return leftNo.localeCompare(rightNo, 'zh-Hant');
}

/**
 * @param {object[]} packages
 * @returns {object[]}
 */
export function sortReceiptPackagesByStockNo(packages = []) {
  return [...(Array.isArray(packages) ? packages : [])].sort((left, right) => {
    const byStockNo = compareStockNoAscEmptyLast(
      resolvePackageStockNo(left),
      resolvePackageStockNo(right),
    );
    if (byStockNo !== 0) {
      return byStockNo;
    }
    return resolvePackageInventoryStockId(left).localeCompare(
      resolvePackageInventoryStockId(right),
      'zh-Hant',
    );
  });
}
